/** Intl formatting (ADR 0017 rule 5): en-MY / ms-MY, user time zone, RM currency. */
import { intlLocale } from "../i18n";

export function partOfDay(date: Date, timeZone: string): "morning" | "afternoon" | "evening" {
  const hour = Number(
    new Intl.DateTimeFormat("en-GB", { hour: "numeric", hour12: false, timeZone }).format(date),
  );
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

export function formatDateTime(date: Date, locale: string, timeZone: string): string {
  return new Intl.DateTimeFormat(intlLocale(locale), {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone,
  }).format(date);
}

export function formatCurrencyMYR(amount: number, locale: string): string {
  return new Intl.NumberFormat(intlLocale(locale), { style: "currency", currency: "MYR" }).format(amount);
}

export function formatRelative(seconds: number, locale: string): string {
  const rtf = new Intl.RelativeTimeFormat(intlLocale(locale), { numeric: "auto" });
  const abs = Math.abs(seconds);
  if (abs < 60) return rtf.format(Math.round(seconds), "second");
  if (abs < 3600) return rtf.format(Math.round(seconds / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(seconds / 3600), "hour");
  return rtf.format(Math.round(seconds / 86400), "day");
}

export function formatDate(iso: string, locale: string, timeZone: string): string {
  return new Intl.DateTimeFormat(intlLocale(locale), { dateStyle: "medium", timeZone }).format(new Date(iso));
}

/** Calendar-day distance from today in the user's time zone (negative = overdue). */
export function daysUntil(iso: string, timeZone: string, now: Date = new Date()): number {
  const day = (d: Date) => new Intl.DateTimeFormat("en-CA", { timeZone }).format(d); // YYYY-MM-DD
  const a = Date.parse(day(now));
  const b = Date.parse(day(new Date(iso)));
  return Math.round((b - a) / 86_400_000);
}

export function secondsSince(iso: string, now: Date = new Date()): number {
  return (Date.parse(iso) - now.getTime()) / 1000;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let u = 0;
  while (v >= 1024 && u < units.length - 1) {
    v /= 1024;
    u++;
  }
  return `${v.toFixed(v >= 10 ? 0 : 1)} ${units[u]}`;
}
